/* Luxury layer for tannrick
   - custom cursor (desktop)
   - scroll-reveal IntersectionObserver
   - count-up animated stats
   - canvas spark particles on hero
   - Three.js procedural metallic brake-disc centerpiece (CDN-loaded)
   - cart drawer using Shopify ajax cart API
   All scoped under body.lux-on so it can be cleanly disabled. */
(function () {
  'use strict';
  if (window.__luxBooted) return;
  window.__luxBooted = true;
  if (!document.body.classList.contains('lux-on')) document.body.classList.add('lux-on');

  var REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DESKTOP = matchMedia('(hover:hover) and (pointer:fine)').matches;
  var SMALL = matchMedia('(max-width: 640px)').matches;

  // ── 0 · sticky-header scroll-shrink (toggle body class on scroll) ──────
  (function stickyHeader() {
    var last = -1;
    function onScroll() {
      var scrolled = window.scrollY > 60;
      if (scrolled !== (last === 1)) {
        document.body.classList.toggle('lux-scrolled', scrolled);
        last = scrolled ? 1 : 0;
      }
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  // ── 1 · custom cursor — DISABLED per user request, use native browser cursor ──

  // ── 2 · scroll-reveal observer ─────────────────────────────────────────
  (function reveal() {
    var els = document.querySelectorAll('.lux-reveal, .lux-reveal-x, .lux-reveal-scale, .lux-counter');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('lux-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('lux-in'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  })();

  // ── 3 · animated count-up ──────────────────────────────────────────────
  (function counters() {
    var nums = document.querySelectorAll('[data-count-to]');
    if (!nums.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var el = entry.target;
        var to = parseFloat(el.getAttribute('data-count-to'));
        var dur = parseInt(el.getAttribute('data-count-dur') || '1800', 10);
        var suffix = el.getAttribute('data-count-suffix') || '';
        var prefix = el.getAttribute('data-count-prefix') || '';
        if (REDUCED) { el.textContent = prefix + to.toLocaleString() + suffix; return; }
        var start = performance.now();
        function tick(now) {
          var t = Math.min(1, (now - start) / dur);
          var eased = 1 - Math.pow(1 - t, 3);
          var v = to * eased;
          el.textContent = prefix + (to >= 100 ? Math.round(v).toLocaleString() : v.toFixed(1)) + suffix;
          if (t < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  })();

  // ── 4 · canvas spark particles on hero ─────────────────────────────────
  (function particles() {
    var host = document.querySelector('.lux-hero__particles');
    if (!host || REDUCED) return;
    var c = document.createElement('canvas');
    c.style.cssText = 'width:100%;height:100%;display:block';
    host.appendChild(c);
    var ctx = c.getContext('2d');
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var W = 0, H = 0, P = [];
    function size() {
      var r = host.getBoundingClientRect();
      W = r.width; H = r.height;
      c.width = W * dpr; c.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var COUNT = Math.min(80, Math.floor((W * H) / 18000));
      P = [];
      for (var i = 0; i < COUNT; i++) {
        P.push({
          x: Math.random() * W, y: Math.random() * H,
          vx: (Math.random() - 0.5) * 0.25, vy: -0.15 - Math.random() * 0.4,
          r: 0.5 + Math.random() * 1.8, a: 0.15 + Math.random() * 0.55,
          hot: Math.random() < 0.7
        });
      }
    }
    size();
    addEventListener('resize', size, { passive: true });
    function frame() {
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < P.length; i++) {
        var p = P[i];
        p.x += p.vx; p.y += p.vy;
        if (p.y < -10 || p.x < -10 || p.x > W + 10) {
          p.x = Math.random() * W; p.y = H + 10;
          p.vx = (Math.random() - 0.5) * 0.25; p.vy = -0.15 - Math.random() * 0.4;
        }
        ctx.beginPath();
        ctx.fillStyle = (p.hot ? 'rgba(255,80,60,' : 'rgba(255,200,90,') + p.a + ')';
        ctx.shadowColor = p.hot ? '#ff3a1a' : '#ffb000';
        ctx.shadowBlur = 6;
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fill();
      }
      requestAnimationFrame(frame);
    }
    frame();
  })();

  // ── 5 · subtle mouse-parallax for real centerpiece photo ───────────────
  (function centerpieceParallax() {
    var host = document.querySelector('.lux-hero__centerpiece');
    if (!host || SMALL || REDUCED || !DESKTOP) return;
    var baseTransform = ''; // we add to the wrapper which is already translateY(-50%)
    var tx = 0, ty = 0, rx = 0, ry = 0;
    window.addEventListener('mousemove', function (e) {
      tx = (e.clientX / innerWidth - 0.5) * 24;   // px
      ty = (e.clientY / innerHeight - 0.5) * 18;  // px
    }, { passive: true });
    (function loop() {
      rx += (tx - rx) * 0.06;
      ry += (ty - ry) * 0.06;
      // wrapper already has translate3d(0,-50%,0); we override with combined transform
      host.style.transform = 'translate3d(' + rx.toFixed(2) + 'px, calc(-50% + ' + ry.toFixed(2) + 'px), 0)';
      requestAnimationFrame(loop);
    })();
  })();

  // ── 5a · inject trust strip + payment methods on PDP under buy form ────
  (function pdpTrustAndPay() {
    if (!document.body.classList.contains('product-product')) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    // Trust strip (idempotent)
    if (!form.parentElement.querySelector('.lux-pdp-trust')) {
      var trust = document.createElement('div');
      trust.className = 'lux-pdp-trust';
      trust.innerHTML = ''
        + '<div class="lux-pdp-trust__item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 8h18l-2 12H5L3 8z"/><path d="M9 14l2 2 4-4"/></svg><span>Verified Fitment</span></div>'
        + '<div class="lux-pdp-trust__item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M16 3h5v13H3V6a3 3 0 013-3h10z"/><circle cx="7" cy="19" r="2"/><circle cx="17" cy="19" r="2"/></svg><span>Fast Dispatch</span></div>'
        + '<div class="lux-pdp-trust__item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3l8 3v6c0 5-4 9-8 9s-8-4-8-9V6l8-3z"/></svg><span>OEM Quality</span></div>';
      form.insertAdjacentElement('afterend', trust);
    }

    // Payment methods (idempotent)
    if (!form.parentElement.querySelector('.lux-pay--pdp')) {
      var tpl = document.getElementById('lux-pay-tpl-pdp');
      if (tpl) {
        var wrap = document.createElement('div');
        wrap.innerHTML = tpl.innerHTML.trim();
        var payEl = wrap.firstElementChild;
        if (payEl) {
          var anchor = form.parentElement.querySelector('.lux-pdp-trust') || form;
          anchor.insertAdjacentElement('afterend', payEl);
        }
      }
    }
  })();

  // ── 5a · desktop header search bar (inject into .box-right) ───────────
  (function headerSearch() {
    var slot = document.querySelector('header.hd2 .box-right') || document.querySelector('header .box-right');
    if (!slot) return;
    if (slot.querySelector('.lux-search')) return;
    var form = document.createElement('form');
    form.className = 'lux-search';
    form.setAttribute('role', 'search');
    form.action = '/search';
    form.method = 'get';
    form.innerHTML = ''
      + '<input type="hidden" name="type" value="product">'
      + '<svg class="lux-search__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>'
      + '<input class="lux-search__input" type="search" name="q" autocomplete="off" placeholder="Search parts, brands, vehicles…" aria-label="Search the store">'
      + '<button class="lux-search__btn" type="submit" aria-label="Search">Search</button>';
    slot.insertBefore(form, slot.firstChild);
  })();

  // ── 5b · sticky add-to-cart on PDP after scroll ────────────────────────
  (function stickyAtc() {
    if (!document.body.classList.contains('product-product')) return;
    if (SMALL) return; // mobile keeps the in-page button
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var titleEl = document.querySelector('.product-shop h1, .product-name h1, h1.title, .product-title');
    var priceEl = document.querySelector('.price-product .money, .product-price .money, .price .money, .product-price, .price');
    var imgEl = document.querySelector('.product-image img, .single-product-image img, .product-gallery img');
    if (!titleEl) return;

    var bar = document.createElement('div'); bar.className = 'lux-sticky-atc';
    bar.innerHTML = ''
      + (imgEl ? '<img src="' + imgEl.currentSrc + '" alt="">' : '')
      + '<div class="lux-sticky-atc__body">'
      +   '<p class="lux-sticky-atc__title">' + (titleEl.textContent || '').trim() + '</p>'
      +   (priceEl ? '<span class="lux-sticky-atc__price">' + priceEl.textContent.trim() + '</span>' : '')
      + '</div>'
      + '<button class="lux-sticky-atc__btn" type="button">Add to Cart →</button>';
    document.body.appendChild(bar);

    bar.querySelector('.lux-sticky-atc__btn').addEventListener('click', function () {
      var submit = form.querySelector('button[name="add"], #addToCart, .btn-addtocart');
      if (submit) submit.click(); else form.submit();
    });

    var formBottom = function () { var r = form.getBoundingClientRect(); return r.top + window.scrollY + r.height; };
    var threshold = formBottom();
    window.addEventListener('resize', function () { threshold = formBottom(); }, { passive: true });
    window.addEventListener('scroll', function () {
      if (window.scrollY > threshold) bar.classList.add('is-on');
      else bar.classList.remove('is-on');
    }, { passive: true });
  })();

  // ── 6 · cart drawer (slide-in, Shopify ajax cart) ──────────────────────
  (function cartDrawer() {
    var drawer = document.createElement('aside'); drawer.className = 'lux-cart-drawer'; drawer.setAttribute('aria-hidden', 'true');
    var payTpl = document.getElementById('lux-pay-tpl-drawer');
    var payHtml = payTpl ? payTpl.innerHTML.trim() : '';
    drawer.innerHTML = ''
      + '<div class="lux-cart-drawer__head"><h3>Your Cart</h3><button class="lux-cart-drawer__close" aria-label="Close cart">×</button></div>'
      + '<div class="lux-cart-drawer__body"><div class="lux-cart-drawer__items"></div></div>'
      + '<div class="lux-cart-drawer__foot">'
      +   '<div class="lux-cart-drawer__sub"><span>Subtotal</span><strong class="lux-cart-drawer__total">$0.00</strong></div>'
      +   '<a class="lux-cart-drawer__checkout" href="/checkout">Checkout</a>'
      +   payHtml
      + '</div>';
    var backdrop = document.createElement('div'); backdrop.className = 'lux-cart-backdrop';
    document.body.appendChild(drawer); document.body.appendChild(backdrop);

    var itemsEl = drawer.querySelector('.lux-cart-drawer__items');
    var totalEl = drawer.querySelector('.lux-cart-drawer__total');

    function close() { drawer.classList.remove('is-open'); backdrop.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    function open() { drawer.classList.add('is-open'); backdrop.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; refresh(); }
    drawer.querySelector('.lux-cart-drawer__close').addEventListener('click', close);
    backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    function money(cents) {
      var fmt = (window.moneyFormat || '${{amount}}');
      var v = (cents / 100).toFixed(2);
      return fmt.replace(/{{\s*amount\s*}}/, v).replace(/{{\s*amount_no_decimals\s*}}/, Math.round(cents / 100));
    }

    function bumpCartCounter(count) {
      document.querySelectorAll('.cart-count, .cartCount').forEach(function (el) {
        el.textContent = count;
        el.classList.remove('lux-pop'); void el.offsetWidth; el.classList.add('lux-pop');
      });
    }

    function refresh() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          bumpCartCounter(cart.item_count || 0);
          if (!cart.items || !cart.items.length) {
            itemsEl.innerHTML = '<div class="lux-cart-empty">Your cart is empty.<br><br>Browse our parts catalogue to get started.</div>';
            totalEl.textContent = money(0);
            return;
          }
          itemsEl.innerHTML = cart.items.map(function (it) {
            var img = it.image || it.featured_image && it.featured_image.url || '';
            return ''
              + '<div class="lux-cart-item" data-key="' + it.key + '">'
              +   '<img class="lux-cart-item__img" src="' + img + '" alt="">'
              +   '<div><span class="lux-cart-item__vendor">' + (it.vendor || '') + '</span>'
              +   '<h5 class="lux-cart-item__title">' + (it.product_title || it.title) + '</h5>'
              +   '<div class="lux-cart-item__qty"><button data-act="dec">−</button><span>' + it.quantity + '</span><button data-act="inc">+</button><button data-act="rem" style="margin-left:8px;border-color:rgba(225,6,0,.4);color:#e10600">×</button></div></div>'
              +   '<span class="lux-cart-item__price">' + money(it.final_line_price) + '</span>'
              + '</div>';
          }).join('');
          totalEl.textContent = money(cart.total_price);
        });
    }

    itemsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-act]'); if (!btn) return;
      var row = btn.closest('.lux-cart-item'); var key = row.getAttribute('data-key');
      var act = btn.getAttribute('data-act');
      var cur = parseInt(row.querySelector('.lux-cart-item__qty span').textContent, 10);
      var nextQty = act === 'inc' ? cur + 1 : act === 'dec' ? Math.max(0, cur - 1) : 0;
      fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: nextQty })
      }).then(refresh);
    });

    // intercept all add-to-cart forms (idempotent: only attach once)
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('form[action*="/cart/add"]'); if (!f) return;
      e.preventDefault();
      var fd = new FormData(f);
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', body: fd })
        .then(function (r) { return r.json(); })
        .then(function () { open(); })
        .catch(function () { f.submit(); });
    });

    // expose openers + add trigger to any [data-lux-cart] button & header cart links
    window.luxCart = { open: open, close: close, refresh: refresh };
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-lux-cart-open], .cart-toggle, .cartCount, a[href="/cart"], a[href$="/cart"]');
      if (t) {
        // do not intercept if user holds modifier (open in new tab)
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault(); open();
      }
    });
  })();
})();
